import { Icon } from '@genial/components';
import { Color } from '@genial/design-tokens';
import React from 'react';

export namespace ItemIconTypes {
  export interface Props {
    isProcessingOrInvalid: boolean;
  }
}

export const ItemIcon: React.FC<ItemIconTypes.Props> = ({ isProcessingOrInvalid }) => (
  <Icon
    name="NewFile"
    color={isProcessingOrInvalid ? Color['neutral.light'] : Color['brand.tertiary.principal']}
    size="sm"
    testId="new-file-button"
  />
);
